import { useEffect, useRef, useState } from "react";
const baseUrl = process.env.REACT_APP_SOCKET_URL;
const getAuthTokens = () => {
  const tokens = localStorage.getItem("authTokens")
    ? JSON.parse(localStorage.getItem("authTokens"))
    : null;
  return tokens;
};
export const useNotificaciones = () => {
  const [notifications, setNotifications] = useState([]);
  const socketRef = useRef(null);

  useEffect(() => {
    const token = getAuthTokens().access;
    const socket = new WebSocket(
      `${baseUrl}/ws/notificaciones/?token=${token}`,
    );
    socketRef.current = socket;
    // Evento: Conexión abierta
    socket.onopen = () => {
      console.log("Conectado al servidor de WebSockets");
    };
    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setNotifications((prev) => [data?.notificacion, ...prev]);
    };
    // Evento: Error
    socket.onerror = (e) => {
      console.error("Error en WebSocket:", e);
    };
    // Limpieza al desmontar el componente
    return () => {
      if (socket) socket.close();
    };
  }, []);
  // Función para enviar mensajes
  const sendNotificacion = (notificacion) => {
    const socket = socketRef.current;
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({ notificacion }));
    }
  };

  return { notifications, sendNotificacion };
};
